(() => {
    // tabs
    const tabsTab = document.querySelectorAll('.tabs-tab');
    const tabsContent = document.querySelectorAll('.tabs-content');
    const tabsRow = document.querySelectorAll('.tabs-row');
    const hash = location.hash.substring(1);

    // set active tab and content on load
    if (hash === 'talent' || hash === 'client') {
        // remove active class for all tabs
        tabsTab.forEach(activeTab => {
            activeTab.classList.remove('active');
        });
        // remove active class for all content
        tabsContent.forEach(activeContent => {
            activeContent.classList.remove('active');
        });
        // set active tab on load
        tabsTab.forEach(activeTab => {
            if (hash === activeTab.dataset.tab) {
                activeTab.classList.add('active');
            }
        });

        // set active content on load
        tabsContent.forEach(activeContent => {
            if (
                hash === activeContent.dataset.tab ||
                activeContent.dataset.tab === 'both'
            ) {
                activeContent.classList.add('active');
            }
        });
    }

    // set active rows on load
    tabsRow.forEach(row => {
        const cards = row.querySelectorAll('.active').length;
        if (cards > 0) {
            row.classList.add('active');
        }
    });

    // set active row and tab on tab click
    tabsTab.forEach(tab => {
        tab.addEventListener('click', e => {
            // remove active class for tab
            tabsTab.forEach(activeTab => {
                activeTab.classList.remove('active');
            });
            // remove active class for rows
            tabsRow.forEach(row => {
                row.classList.remove('active');
            });

            // remove active class for tab content
            tabsContent.forEach(activeContent => {
                activeContent.classList.remove('active');
                // add active class to active tab content
                if (
                    e.currentTarget.dataset.tab === activeContent.dataset.tab ||
                    activeContent.dataset.tab === 'both'
                ) {
                    activeContent.classList.add('active');
                }
            });
            // set active class for rows after tabs with content are active
            tabsRow.forEach(row => {
                const cards = row.querySelectorAll('.active').length;
                if (cards > 0) {
                    row.classList.add('active');
                }
            });
            // set active button
            e.currentTarget.classList.add('active');
        });
    });
})();
